export default function faq() {

    jQuery(".schema-faq-answer").addClass('collapse');

    jQuery(".schema-faq-question").click(function () {
        jQuery(this).siblings().collapse('toggle');
    });

    jQuery(window).scroll(function () {
        var scrollToTop = jQuery('.scroll-to-top');
        if (500 < jQuery(document).scrollTop()) {
            scrollToTop.css('opacity', '1');
        } else {
            scrollToTop.css('opacity', '0');
        }
    });

}
